import React from "react";

const ContactsIcon = ({ stroke="#919293", ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props} // Spread additional props (e.g., className, style)
  >
    <rect
      x="2"
      y="2"
      width="14"
      height="14"
      rx="2"
      stroke={stroke}
      strokeWidth="1.3"
    />
    <mask id="path-2-inside-1_1651_3229" fill="white">
      <rect x="4" y="4" width="10" height="4" rx="1" />
    </mask>
    <rect
      x="4"
      y="4"
      width="10"
      height="4"
      rx="1"
      stroke={stroke}
      strokeWidth="2.6"
      mask="url(#path-2-inside-1_1651_3229)"
    />
    <mask id="path-3-inside-2_1651_3229" fill="white">
      <rect x="10" y="10" width="4" height="4" rx="1" />
    </mask>
    <rect
      x="10"
      y="10"
      width="4"
      height="4"
      rx="1"
      stroke={stroke}
      strokeWidth="2.6"
      mask="url(#path-3-inside-2_1651_3229)"
    />
    <path
      d="M4.5 10.5153L7.49902 10.5153"
      stroke={stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <path
      d="M4.5 13.5105L7.49902 13.5105"
      stroke={stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

export default ContactsIcon;
